export default class OrderClient {
  constructor({ url, _post, _put }) {
    this.url = url
    this.post = _post
    this.put = _put
  }

  help() {
    console.log('create(drop_slug)')
    console.log('update(unsavedOrder)')
    console.log('complete(unsavedOrder)')
  }

  new() {
    return {
      id: null,
      drop_slug: ''
    }
  }

  async create(drop_slug) {
    const fallback = this.new()
    const url = `${this.url}/api/v1/checkout/${drop_slug}`
    const { payment_intent } = await this.post(url, null, null, fallback)

    return payment_intent
  }

  async update(unsavedOrder) {
    const fallback = { order: {} }
    const url = `${this.url}/api/v1/checkout/update`
    const { order } = await this.put(url, null, unsavedOrder, fallback)

    return order
  }

  async complete(unsavedOrder) {
    const fallback = { order: {} }
    const url = `${this.url}/api/v1/checkout/complete`
    const { order } = await this.put(url, null, unsavedOrder, fallback)

    return order
  }
}
